import { List, Map } from 'immutable';
import { createSelector } from 'reselect';
import { denormalizeModelList } from '../../utils/Normalizer';

const selectOffersHistory = (state) => state.getIn(['fundingSearch', 'offersHistory'], Map());

const makeSelectOffersHistoryByMatchId = (matchId) =>
  createSelector(selectOffersHistory, (state) =>
    denormalizeModelList(
      state.get('byId', List()),
      state.getIn(['groupByFundingMatchId', matchId], List()),
    ),
  );

const makeSelectOffersHistoryByOfferId = (matchId, offerId) =>
  createSelector(
    makeSelectOffersHistoryByMatchId(String(matchId)),
    (state) => state.find((offer) => offer.id === offerId) || Map(),
  );

const makeSelectOffersHistoryError = () =>
  createSelector(selectOffersHistory, (state) => state.getIn(['network', 'error'], false));

const makeSelectOffersHistoryLoading = () =>
  createSelector(selectOffersHistory, (state) => state.getIn(['network', 'loading'], false));

export {
  makeSelectOffersHistoryByMatchId,
  makeSelectOffersHistoryByOfferId,
  makeSelectOffersHistoryError,
  makeSelectOffersHistoryLoading,
  selectOffersHistory,
};
